import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {LogoService} from '../../core/services/logo-service/logo.service';
import {UserService} from '../../core/services/user-service/user.service';

type MenuItem = {
  title: string;
  icon?: string;
  route?: string;
  children?: MenuItem[];
};

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent {
  constructor(
    public router: Router,
    private logoService: LogoService,
    private userService:UserService,
  ) {
  }
  customersStatusOptions: string = '';
  isSitesCollapsed = false;
  isSidebarCollapse = false;
  toggle = true;
  logoUrl:string = ''
  menuItems: MenuItem[] = [
    {
      title: 'Dashboard',
      icon: '/assets/icons/dashboard.svg',
      route: '/dashboard',
    },
    {
      title: 'Talent Pool',
      icon: '/assets/icons/talentPool.svg',
      route: '/talent_pool',
    },
    {
      title: 'Solution Pool',
      icon: '/assets/icons/solutionPool.svg',
      route: '/solution_pool',
    },
    {
      title: 'Sites',
      children: [
        {
          title: 'My List',
          icon: '/assets/icons/myList.svg',
          route: '/myList'
        },
        {
          title: 'Jobs',
          icon: '/assets/icons/job.svg',
          route: '/jobs'
        },
        {
          title: 'Themes',
          icon: '/assets/icons/theme.svg',
          route: '/themes'
        }
      ]
    }
  ];

  ngOnInit() {
    this.logoService.logo$.subscribe((url) => {
      if (url) {
        this.logoUrl = url;
      }
    });
    this.userService.getUser().subscribe({
      next: (res: any) => {
        this.customersStatusOptions = res?.verificationStatus ?? '';
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  isActive(route?: string): boolean {
    return route ? this.router.url.startsWith(route) : false;
  }

  toggleSidebar(): void {
    const aside = document.getElementById('side-bar');
    const mainContentId = document.getElementById('main-content');
    const displayHidden = document.getElementsByClassName('hide');
    const sitesDisplay = document.getElementById('sidebar-collapse');
    const logo = document.getElementById('logo') as HTMLImageElement | null;

    if (this.toggle) {
      this.isSidebarCollapse = true;
      if (logo) logo.src = '/assets/icons/proteamate_logo_small.svg';
      if (aside) aside.className = 'xl:w-[90px] w-[70px] transition-all duration-500 ease-in-out';
      if (mainContentId) mainContentId.className = 'w-[96vw]';
      if (sitesDisplay) sitesDisplay.className = 'text-sm font-bold text-gray-500';
      for (let i = 0; i < displayHidden.length; i++) {
        displayHidden[i].classList.add('hidden');
      }
    } else {
      if (logo) logo.src = '/assets/icons/ptm-header-logo.svg';
      if (aside) aside.className = 'xl:w-[300px] w-[200px] transition-all duration-500 ease-in-out';
      if (sitesDisplay) sitesDisplay.className = 'text-sm font-bold text-gray-500 ml-3';
      for (let i = 0; i < displayHidden.length; i++) {
        displayHidden[i].classList.remove('hidden');
      }
      this.isSidebarCollapse = false;
    }

    this.toggle = !this.toggle;
  }
}
